import MainLayout from "../components/layout/MainLayout";
import MainLayoutUser from "../components/layout/MainLayoutUser";
import MainLayoutAdmin from "../components/layout/MainLayoutAdmin";

import Banner from "../components/organisms/Banner";
import JobListingGridHome from "../components/organisms/JobListingGridHome";
import ClientListSection from "../components/organisms/ClientListSection";
import Testimonial from "../components/organisms/Testimonial";
import EventHome from "../components/organisms/EventHome";

import { useEffect } from "react";
import { useAuthStore } from "../store/useAuthStore";

export default function Home() {
  const { accessToken, type } = useAuthStore();

  useEffect(() => {
    document.title = "TalentLink | Home";

    // Meta description
    let metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute("content", "TalentLink is a premier headhunting and talent management firm dedicated to bridging exceptional talent with forward-thinking companies.");
    }

    // Meta keywords
    let metaKeywords = document.querySelector("meta[name='keywords']");
    if (!metaKeywords) {
      metaKeywords = document.createElement("meta");
      metaKeywords.setAttribute("name", "keywords");
      document.head.appendChild(metaKeywords);
    }

    metaKeywords.setAttribute(
      "content",
      "talentlink,indo,PT. Nusaraya,talent,nusa,raya,Link,indonesia,headhunting,headhunter Indonesia,Mandarin,Candidate,Jobseeker,China,Tiongkok,lowongan kerja,cari kerja,hiring,lowongan kerja,loker terbaru, 高管搜寻，猎头，印尼猎头，印度尼西亚猎头，高端人才，人才，中文，中文人才，普通话，中国，台湾，香港，新加坡，招聘，求职，找工作，找人才，人才市场，招聘会，简历，面试，白领，办公室，雅加达，万隆，泗水，三宝垄，东南亚，最好，最快，最大，招聘网站，英文，印尼语，留学生，HSK, 汉语考试，孔子学院，中国使馆，签证，人事外包，外包，人工智能，匹配，职位，岗位，工资，福利，录用通知，劳动合同，劳动法，雇佣，员工关系，人力资源，公司高管，总监，总经理，大学,"
    );
  }, []);

  // Pilih layout sesuai login
  const Layout =
    !accessToken
      ? MainLayout
      : type === "candidate"
        ? MainLayoutUser
        : type === "company"
          ? MainLayoutAdmin
          : MainLayout;

  return (
    <Layout>
      <Banner />
      <JobListingGridHome />
      <ClientListSection />
      <Testimonial />
      <EventHome />
    </Layout>
  );
}
